import "../../firebase"; // inicializa o app Firebase antes do getFunctions abaixo
import { getFunctions, httpsCallable } from "firebase/functions";

// Cliente das Cloud Functions de importação do MakerWorld. O browser NUNCA
// fala com o MakerWorld direto (CORS + frágil): tudo passa pelo backend.
const fns = getFunctions(undefined, "us-central1");
const cfBuscar = httpsCallable(fns, "buscarFotosMakerWorld");
const cfImportar = httpsCallable(fns, "importarFotosMakerWorld", { timeout: 180000 });
const cfMiniaturas = httpsCallable(fns, "miniaturasFotosMakerWorld", { timeout: 60000 });

const MSG_SERVIDOR = "Não foi possível falar com o servidor agora. Tente novamente em instantes.";

// As mensagens que o backend devolve já são amigáveis e passam direto. Quando a
// mensagem é só o nome do código ("internal", "not-found"…), quem a gerou foi o
// próprio SDK: a requisição nem chegou na função (sem internet, CORS, função
// não publicada). Isso NÃO é problema do MakerWorld, então não usa a mensagem
// de "fotos do modelo". O detalhe técnico fica no console pra diagnóstico.
function erroAmigavel(e) {
  console.error("MakerWorld:", e?.code, e?.message, e?.details);
  const codigo = String(e?.code || "");
  const msg = typeof e?.message === "string" ? e.message.trim() : "";
  if (!codigo.startsWith("functions/") || !msg) return new Error(MSG_SERVIDOR);
  const msgDoSdk = msg.toLowerCase().replace(/_/g, "-") === codigo.slice("functions/".length);
  return new Error(msgDoSdk ? MSG_SERVIDOR : msg);
}

// link -> { modelId, title, sourceUrl, cover, images: [{ id, url, thumb, origem }] }
export async function buscarFotosMakerWorld(url) {
  try { return (await cfBuscar({ url })).data; }
  catch (e) { throw erroAmigavel(e); }
}

// Miniaturas (400 px) das fotos escolhidas já em base64 (data URL), até 8 por vez.
// Nada é gravado — servem de prévia e são as fotos que vão dentro do orçamento.
// Devolve { importadas: [{ id, url }], falhas: [{ id, motivo }] }.
export async function miniaturasFotosMakerWorld({ url, ids }) {
  try { return (await cfMiniaturas({ url, ids })).data; }
  catch (e) { throw erroAmigavel(e); }
}

// Manda o link + IDs das fotos escolhidas (nunca URLs de imagem). Devolve
// { importadas: [{ id, path, url }], falhas: [{ id, motivo }] } — as fotos já
// estão no Storage do produto.
export async function importarFotosMakerWorld({ url, ids, produtoId }) {
  try { return (await cfImportar({ url, ids, produtoId })).data; }
  catch (e) { throw erroAmigavel(e); }
}
